document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".hc-faq-trigger").forEach(trigger => {
    trigger.addEventListener("click", function () {
      let sectionValue = this.getAttribute("data-section");
      let relatedElements = document.querySelectorAll(`.hc-answer-question[data-section='${sectionValue}']`);

      this.classList.toggle('hc-opened');
      relatedElements.forEach(element => {
        if (element.style.display === "none" || element.style.display === "") {
          element.style.display = "block";
        } else {
          element.style.display = "none";
        }
      });
    });
  });
});

function scrollToAndClickDataQ() {
  if (!document.querySelector('.hc-template-faq')) return;

  let hash = decodeURIComponent(window.location.hash.substring(1));
  if (!hash) return;

  const [primary, secondary] = hash.split('?');

  const target = document.querySelector(`[data-q="${primary}"]`);
  if (!target) return;

  const scrollToWithOffset = (element) => {
    const y = element.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({ top: y, behavior: 'smooth' });
  };

  scrollToWithOffset(target);

  setTimeout(() => {
    target.click();

    if (secondary) {
      const subTarget = document.querySelector(`[data-q-b="${secondary}"]`);
      if (subTarget) {
        setTimeout(() => {
          scrollToWithOffset(subTarget);
          setTimeout(() => {
            subTarget.click();
          }, 200);
        }, 400);
      }
    }
  }, 800);
}

window.addEventListener('DOMContentLoaded', scrollToAndClickDataQ);
window.addEventListener('hashchange', scrollToAndClickDataQ);

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.hc-show-more, .hc-show-less').forEach(function (b) {
    const d = getComputedStyle(b).display;
    b.dataset.defaultDisplay = d === 'none' ? 'inline-block' : d;
  });
});

document.addEventListener('click', function (e) {
  const moreBtn = e.target.closest('.hc-show-more');
  const lessBtn = e.target.closest('.hc-show-less');

  if (moreBtn) {
    const sectionId = moreBtn.getAttribute('data-section');
    // reveal all wrappers for this section
    document.querySelectorAll('.hc-metaobject-image-wrapper[data-section="' + sectionId + '"]')
      .forEach(function (w) { w.classList.remove('hc-show-less-content'); });

    document.querySelectorAll('.hc-show-more[data-section="' + sectionId + '"]')
      .forEach(function (b) { b.style.display = 'none'; b.removeAttribute('hidden'); });
    document.querySelectorAll('.hc-show-less[data-section="' + sectionId + '"]')
      .forEach(function (b) { b.removeAttribute('hidden'); b.style.display = b.dataset.defaultDisplay || 'inline-block'; });
  }

  if (lessBtn) {
    const sectionId = lessBtn.getAttribute('data-section');
    document.querySelectorAll('.hc-metaobject-image-wrapper[data-section="' + sectionId + '"]')
      .forEach(function (w) { w.classList.add('hc-show-less-content'); });

    document.querySelectorAll('.hc-show-less[data-section="' + sectionId + '"]')
      .forEach(function (b) { b.style.display = 'none'; b.removeAttribute('hidden'); });
    document.querySelectorAll('.hc-show-more[data-section="' + sectionId + '"]')
      .forEach(function (b) { b.removeAttribute('hidden'); b.style.display = b.dataset.defaultDisplay || 'inline-block'; });
  }
});
document.addEventListener('DOMContentLoaded', function () {
  var trigger = document.querySelector('.klaviyo_form_trigger');
  if (!trigger) return;
  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    if (window.klaviyo && typeof window.klaviyo.push === 'function') {
      window.klaviyo.push(['openForm', 'WRFhXJ']);
    } else {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'WRFhXJ']);
    }
  });
});